import { useState } from 'react';
import Board from '../../components/Board/Board';
import ContextMenu from '../../components/ContextMenu/ContextMenu';
import './Game.scss';
import { ChoseFigure } from 'services/WebSocketService/types/ChoseFigure';
import { ToastContainer, Zoom } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

interface Player {
  uid: string;
  name: string;
  color: 'white' | 'black';
  isActive: boolean;
  timeLeft: number;
}

type PlayerState = Record<string, Player>; // Players indexed by UID

function GameLayout() {
  const [choseFigurePos, setChoseFigurePos] = useState<ChoseFigure | null>(null);
  const [players, setPlayers] = useState<PlayerState>({});

  // Function to initialize a player when they join
  const initPlayers = (data: Array<{ color: 'white' | 'black'; name: string; uid: string; player_time: number }>) => {
    setPlayers((prevPlayers) => {
      const updatedPlayers = { ...prevPlayers };

      data.forEach(({ uid, name, color, player_time }) => {
        if (!updatedPlayers[uid]) {
          updatedPlayers[uid] = {
            uid,
            name,
            color,
            isActive: Object.keys(prevPlayers).length === 0, // First player is active
            timeLeft: player_time, // Initialize with provided time
          };
        }
      });

      return updatedPlayers;
    });
  };


  const setTimerState = (data: { timers: Record<string, number>; active_player: string }) => {

    setPlayers((prevPlayers) => {
      const updatedPlayers = { ...prevPlayers };

      // Update timers
      Object.entries(data.timers).forEach(([uid, timeLeft]) => {
        if (updatedPlayers[uid]) {
          updatedPlayers[uid] = { ...updatedPlayers[uid], timeLeft };
        }
      });

      // Set active player
      Object.keys(updatedPlayers).forEach((uid) => {
        updatedPlayers[uid].isActive = uid === data.active_player;
      });

      return updatedPlayers;
    });
  };

  // Format time for display
  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const sec = seconds % 60;
    return `${minutes}:${sec < 10 ? '0' : ''}${sec}`;
  };

  return (
    <div className="app">


      <div className="game-layout">
        <ToastContainer
          position="top-center"
          autoClose={5000}
          limit={3}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
          transition={Zoom}
        />

        {/* Pass setTimerState & initPlayer to Board */}
        <Board
          choseFigurePos={choseFigurePos}
          setChoseFigurePos={setChoseFigurePos}
          setTimerState={setTimerState}
          initPlayers={initPlayers}
        />

        {/* Active Player Cards (Above ContextMenu) */}
        <div className="info-container">
          <div className="active-players">
            {Object.values(players)
              .filter((player) => player.color === 'white' || player.color === 'black') // Only show actual players
              .map((player) => (
                <div key={player.uid} className={`player-card ${player.isActive ? 'active' : ''}`}>
                  <div className="player-name">{player.name} ({player.color})</div>
                  <div className="player-timer">{formatTime(player.timeLeft)}</div>
                </div>
              ))}
          </div>
          <ContextMenu choseFigurePos={choseFigurePos} setChoseFigurePos={setChoseFigurePos} />
        </div>
      </div>
    </div>
  );
}

export default GameLayout;
